import { v4 as uuidv4 } from "uuid";
const axios = require("axios");

const JL_UI_CORRELATION_HEADER = "JL-UI-CORRELATION-ID-V1";
const correlationId = `help-ui-${uuidv4()}`;

const createAxiosClient = async (config = {}) => {
  const client = await axios.create({
    ...config,
    headers: { ...config.headers, [JL_UI_CORRELATION_HEADER]: correlationId },
  });

  return client;
};

export default createAxiosClient;
